import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { round4 as round } from 'utilities/math';

import Input from 'components/Input';

class ZScoreFieldComponent extends React.PureComponent {
  constructor (props) {
    super(props);

    this.formatFn = value =>
      value || value === 0
        ? round(value)
        : '';
  }

  render () {
    return (
      <Field
        step={0.1}
        type="number"
        component={Input}
        format={this.formatFn}

        labelClassName="main-input__label width-auto"
        wrapperClassName={`mb-0 relative flex baseline justify-end iconTop ${this.props.wrapperClass}`}
        inputClassName="main-input__input mt-20 max-100 ml-3"
        {...this.props}
      />
    );
  }
}

ZScoreFieldComponent.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  wrapperClass: PropTypes.string,
  validate: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ZScoreFieldComponent;
